module.exports = __webpack_public_path__ + "static/media/YM29_0.a8bbfc16.jpg";